import { warningText } from './holidayWarningText';

/**
 * Abschnitt 5: ob der Server diesen Entwurf schon geprüft hat, was „Wirkung prüfen“ tut, und seine
 * Hinweise – die aus dem Laden kommen schon vor dem ersten Speichern.
 */
export function SafetyPreviewSection({
  serverErrors,
  checked,
  warnings,
  horizonDays,
}: {
  serverErrors: number;
  /** Der Server hat genau diesen Entwurf geprüft und „Wirkung prüfen“ freigegeben. */
  checked: boolean;
  warnings: string[];
  horizonDays: number;
}) {
  const status =
    serverErrors > 0
      ? `Der Server hat ${serverErrors === 1 ? 'einen Fehler' : `${serverErrors} Fehler`} gefunden – siehe oben.`
      : checked
        ? 'Der Server hat diesen Entwurf geprüft.'
        : 'Ob die Vorschau möglich ist, prüft der Server beim Klick auf „Wirkung prüfen“.';
  return (
    <>
      <span className="text-sm">{status}</span>
      <span className="text-ink-soft text-xs">
        Vor jedem Einschalten rechnet der Server die Wirkung für alle {horizonDays} Tage durch. Erst
        danach lässt sich die neue Version aktivieren. „Aus“ wird ohne Vorschau gespeichert.
      </span>
      {warnings.length > 0 && (
        <ul className="flex flex-col gap-1.5">
          {warnings.map((code) => (
            <li key={code} className="bg-amber-tint text-ink rounded-control px-3 py-2 text-[13px]">
              {warningText(code)}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
